import script from "./DocPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocPage.vue?vue&type=script&setup=true&lang=ts"

import "./DocPage.vue?vue&type=style&index=0&id=73658aa8&scoped=true&lang=css"

import exportComponent from "/opt/sources/madarion/mdnw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73658aa8"]])

export default __exports__